import { useSelector } from 'react-redux';
import { Button } from 'rsuite';
import { FilterPlaceholder } from '../../../../../components/FilterPlaceholder';
import { Layout } from '../../../../../components/Layout';
import { selectorSegmentos } from '../../../../../reducers/gerenciadorPrecos/segmentos';
import { useNetworkPricesStore } from '../../NetworkPrices.store';
import { isNetworkCategorySegment } from '../../utils';
import { NetworkFilterChip } from './NetworkFilterChip';
import styles from './NetworkPricesFilters.module.scss';

const FAMILY_PASTE_TEXT = 'Escreva ou cole uma lista de códigos de família separados por espaço ou pelos caracteres , ; |  ';

export const NetworkPricesFilters = () => {
  const categories = useSelector(selectorSegmentos).filter(isNetworkCategorySegment);
  const clearFilters = useNetworkPricesStore(state => state.clearFilters);

  return (
    <Layout.Section padded>
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <NetworkFilterChip filterKey="productIds" pasteValues placeholder={<FilterPlaceholder dataKey="productIds" placeholder="Produtos" />} />
          <NetworkFilterChip
            filterKey="productFamilyIds"
            pasteValues
            modalText={FAMILY_PASTE_TEXT}
            placeholder={<FilterPlaceholder dataKey="productFamilyIds" placeholder="Família" />}
          />
          <NetworkFilterChip filterKey="productBrand" placeholder={<FilterPlaceholder dataKey="productBrand" placeholder="Marca" />} />
          <NetworkFilterChip filterKey="supplier" placeholder={<FilterPlaceholder dataKey="supplier" placeholder="Fornecedor" />} />
          <div className={styles.actions}>
            <Button className={styles.clearButton} onClick={clearFilters}>
              Limpar filtros
            </Button>
          </div>
        </div>
        <div className={styles.row}>
          {categories.map(({ value, name }) => (
            // FilterPlaceholder reads the level number ("01") from the categoryLevelN key.
            <NetworkFilterChip key={value} filterKey={value} placeholder={<FilterPlaceholder dataKey={value} placeholder={name} />} />
          ))}
        </div>
      </div>
    </Layout.Section>
  );
};
